import { inspectionClient } from '../config/api';
import {
  CreateInspectionIssueRequest,
  CreateInspectionIssueResponse,
  ResolveInspectionIssueRequest,
  ResolveInspectionIssueResponse,
  AddIssueCommentRequest,
  AddIssueCommentResponse,
  InspectionIssue,
  GetInspectionIssuesParams
} from './types/inspectionIssues.types';
import { apiErrorHandler } from '@/helpers/apiErrorHandler';

class InspectionIssuesService {
  
  async createIssue(itemId: string, request: CreateInspectionIssueRequest): Promise<CreateInspectionIssueResponse> {
    try {
      const response = await inspectionClient.post<CreateInspectionIssueResponse>(
        `/api/inspection-items/${itemId}/issues`,
        request
      );

      return response.data;
    } catch (error: unknown) {
      apiErrorHandler(error, 'Erro ao criar pendência');
    }
  }

  async getIssuesByInspection(params: GetInspectionIssuesParams): Promise<InspectionIssue[]> {
    try {
      const response = await inspectionClient.get<{ data: InspectionIssue[] }>(
        `/api/inspection-items/${params.inspectionItemId}/issues`
      );

      const issues = response.data.data || response.data || [];

      return Array.isArray(issues) ? issues : [];
    } catch (error: unknown) {
      apiErrorHandler(error, 'Erro ao buscar pendências');
    }
  }

  async resolveIssue(issueId: string, request: ResolveInspectionIssueRequest): Promise<ResolveInspectionIssueResponse> {
    try {
      const response = await inspectionClient.post<ResolveInspectionIssueResponse>(
        `/api/inspection-issues/${issueId}/resolve`,
        request
      );

      return response.data;
    } catch (error: unknown) {
      apiErrorHandler(error, 'Erro ao resolver pendência');
    }
  }

  async addComment(issueId: string, request: AddIssueCommentRequest): Promise<AddIssueCommentResponse> {
    try {
      const response = await inspectionClient.post<AddIssueCommentResponse>(
        `/api/inspection-issues/${issueId}/comments`,
        request
      );

      return response.data;
    } catch (error: unknown) {
      apiErrorHandler(error, 'Erro ao adicionar comentário');
    }
  }

  async getIssueById(issueId: string): Promise<InspectionIssue> {
    try {
      const response = await inspectionClient.get<{ data: InspectionIssue }>(
        `/api/inspection-issues/${issueId}`
      );

      return response.data.data;
    } catch (error: unknown) {
      apiErrorHandler(error, 'Erro ao buscar pendência');
    }
  }
}

export const inspectionIssuesService = new InspectionIssuesService();